<label class="zui-gray4-text-color zui-mediumtext" *ngIf="options.title.enable">{{options.title.text}}</label>
<svg width="100%" height="100%" class="zui-content"></svg>